import { useEffect, useRef, useState, Component } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/index.css";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Questionnaire from "./pages/Questionnaire";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

function ScrollManager() {
  const { pathname } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.1 });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function SiteLayout() {
  return (
    <div className="grain min-h-screen">
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

class ErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed) {
      return (
        <div className="grid min-h-screen place-items-center bg-paper px-6 text-center">
          <div>
            <p className="eyebrow text-ember">Something broke</p>
            <p className="mt-4 font-display text-3xl font-bold">We'll be back in a moment.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center bg-paper px-6 text-center">
      <div>
        <p className="eyebrow text-ember">404</p>
        <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight">
          This page lost its temper.
        </h1>
        <a href="/" data-testid="notfound-home-link" className="btn-ink mt-8">
          Back home
        </a>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollManager />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/temper-profile" element={<Questionnaire />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
